import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Label
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getPayoutList, deletePayout } from "../../../redux/actions/payoutActions";
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
import '../../../style/react-datetimepicker.scss';

import ReactHtmlParser from 'react-html-parser';
import Dialog from 'react-bootstrap-dialog';
import DateTimePicker from 'react-datetime-picker';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import Pagination from 'react-paginating';
const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let isLoading="false";

class PayoutTermList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Merchant Payment Terms'], 
      links: ["home",'payment_terms/list'],
      alertMessage: '',
      show: false,
      totalRecords: 0,
      perPage: 0,
      limit:25,
      currentPage: 1,
      pageCount:0,
      payoutList: '',
    }

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  
  deletePayouts = (e) => {
    let id = e.target.attributes.getNamedItem('data-key').value;
    this.dialog.show({
      body: 'Are you sure you want to delete this?',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.deleteTerm(id);
        })
      ]
    })
  }

  deleteTerm = (id) => {
    isLoading = "true";
    this.props.deletePayout(id);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e){
    this.setState({[e.target.name]:e.target.value}) 
  }

  Clear = () => {
    
  }


  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page
    });
    this.props.getPayoutList({page:page,limit: this.state.limit});
  };


  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.handlePageChange();
  }

  componentWillReceiveProps(nextProps){     
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
        }
      } 

      if(this.props.deleteStatus !== nextProps.deleteStatus){
        if(nextProps.deleteStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.deleteStatus.message);
          isLoading="false";
          window.scrollTo(0, 0);
          this.handlePageChange();
        }
      }

      if(this.props.payoutList !== nextProps.payoutList){
        if(nextProps.payoutList){
          isLoading="false";
          const setPageCount = nextProps.payoutList.data.total / nextProps.payoutList.data.per_page;
          this.setState({payoutList: nextProps.payoutList.data, totalRecords:nextProps.payoutList.data.total, perPage:nextProps.payoutList.data.per_page, pageCount:setPageCount})
        }
      }

      if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }
     
  }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state
    
    
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Merchant Payment Terms</header>
          {this.state.show && this.state.alertMessage !=='' &&        
            <div className="col-lg-12">
              <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
            </Alert>
            </div>
          }
          <div className="panel-body">
            <div className="row">
              <div className="col-lg-12 text-right">
                <Button
                  bsSize="small"
                  bsStyle="success"
                  onClick={() => this.context.router.history.push("/payout-terms/add")}
                >
                  + Add Payout Terms
                </Button>
              </div>
            </div><br/>
            <div className="row">
              <div className="col-lg-12">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Payment Type</th>
                  <th>Per Download</th>
                  <th>Per Redemption</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                  {(this.state.payoutList !== '') ?
                    this.state.payoutList.data.map((data, index) => 
                      <tr key={Math.random() + index}>
                        <td>{++index}</td>
                        <td>{data.termName}</td>
                        <td>{data.paymentType}</td>
                        <td>{data.amountPerDownload}</td>
                        <td>{data.amountPerRedemption}</td>
                        <td>
                          <ButtonGroup>
                            <DropdownButton title="Action" id="bg-nested-dropdown">
                              <MenuItem eventKey={Math.random()}  onClick={() => this.context.router.history.push(`/payout-terms/edit/${data.termID}`)}><i className="glyphicon glyphicon-eye-open"></i>Edit</MenuItem>
                              <MenuItem eventKey={Math.random()}  data-key={data.termID} onClick={this.deletePayouts}><i className="glyphicon glyphicon-eye-open"></i>Delete</MenuItem>
                            </DropdownButton>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ) : <tr><td colSpan={6}>Data Not Found</td></tr>
                  }
              </tbody>
            </table>
            <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={5}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div> 
       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.payoutReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      payoutList:  state.payoutReducer.payoutList,
      deleteStatus:  state.payoutReducer.deleteStatus,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, getPayoutList, deletePayout})
)(PayoutTermList);



// WEBPACK FOOTER //
// ./src/app/views/admin/payoutTerms/PayoutTermList.js